module.exports = __webpack_public_path__ + "img/blue_114.13f2d9e2.png";